import * as types from './constants';
import endpoints from '../../constants/endpoints';
import { getHttpInstance } from '../../services/defaultHttpService';
import { replaceTokensInString } from '../../utils';
import { normalizeError } from '../exception/utils';
import { clearError, setError } from '../exception/actions';
import { loadSavedListDetails } from '../account/actions';
import { ERROR_DOMAIN, ERROR_PATH } from '../../constants/errorConstants';
import { STATUS } from '@app/constants/commonConstants';

export const getDealerCustomerStores =
  ({ customerNumber, errorPath, errorMessageInfo = {} } = {}) =>
  (dispatch, getState) => {
    const { storeId, selectedCustomerNumber, langId } = getState().common;
    dispatch({ type: types.DEALER_CUSTOMER_STORES_GET_BEGIN });
    const http = getHttpInstance();
    const dcn = customerNumber || selectedCustomerNumber;
    const url = replaceTokensInString(
      endpoints.DEALER_CUSTOMER_SERVICE,
      storeId,
      dcn,
      langId
    );
    return http
      .get(url)
      .then(({ data } = {}) => {
        dispatch({
          type: types.DEALER_CUSTOMER_STORES_GET_SUCCESS,
          payload: { ...data, id: dcn }
        });
        dispatch(
          clearError(ERROR_DOMAIN.CART, ERROR_PATH.EDIT_ORDER_INFORMATION)
        );
      })
      .catch(e => {
        dispatch({
          type: types.DEALER_CUSTOMER_STORES_GET_FAIL,
          payload: e
        });
        const unknownError = {
          title: 'UNKNOWN_ERROR_TITLE',
          message: 'UNKNOWN_ERROR_MESSAGE',
          severity: 'error'
        };
        if (errorPath) {
          const { domain, path } = errorPath;
          if (domain && path) {
            dispatch(
              setError(domain, path, {
                ...normalizeError(e),
                ...errorMessageInfo
              })
            );
          }
        } else {
          dispatch(setError(ERROR_DOMAIN.ADP, ERROR_PATH.STORES, unknownError));
        }
      });
  };

export const shareSelectedList =
  ({ ucidList, requisitionListId }) =>
  (dispatch, getState) => {
    const http = getHttpInstance();

    const {
      common: { storeId },
      account: { searchOptions }
    } = getState();
    dispatch({
      type: types.DEALER_CUSTOMER_SHARE_UCID_LIST_BEGIN
    });

    const url = replaceTokensInString(
      endpoints.SAVED_LIST_SHARE_UCID_LIST,
      storeId
    );

    return http
      .post(url, { ucidList, requisitionListId })
      .then(() => {
        dispatch({
          type: types.DEALER_CUSTOMER_SHARE_UCID_LIST_SUCCESS,
          payload: STATUS.RESOLVED
        });
        dispatch(loadSavedListDetails(searchOptions));
      })
      .catch(() => {
        dispatch({
          type: types.DEALER_CUSTOMER_SHARE_UCID_LIST_FAIL,
          payload: STATUS.REJECTED
        });
      });
  };
